import type { Fact } from "../types/fact";

export const facts: Fact[] = [
  { key: "based in", value: "Toronto, ON" },
  { key: "education", value: "Humber Polytechnic — IT Solutions" },
  { key: "experience", value: "2+ years in web development" },
  { key: "shipped projects", value: "4+ live projects" },
  { key: "certifications", value: "Google UX Design, AWS Cloud" },
  { key: "open to", value: "Frontend and full-stack roles" },
];
